import { Core } from '@pdftron/webviewer';

export default class Utils {
  private static repeatIcon: HTMLImageElement | null = null;

  public static annotationOptions = {
    // unselected style
    unselectedRectangeGrowthValue: 1,
    unselectedAnnotationBorderThickness: 1,
    unselectedAnnotationColor: {
      A: 0.8,
      R: 242,
      G: 70,
      B: 66,
    } as Core.Annotations.Color,
    // selected style
    selectedRectangeGrowthValue: 3,
    selectedAnnotationBorderThickness: 2,
    selectedAnnotationColor: {
      A: 0.9,
      R: 200,
      G: 30,
      B: 30,
    } as Core.Annotations.Color,
    // deletion/insertion style
    hiddenAnnotationBorderThickness: 1,
    hiddenAnnotationColor: {
      A: 0,
    } as Core.Annotations.Color,
  };

  /* eslint-disable no-param-reassign*/
  public static styleSelectedRectangleAnnotation(annot: Core.Annotations.RectangleAnnotation, grow = true): void {
    annot.StrokeThickness = Utils.annotationOptions.selectedAnnotationBorderThickness;
    annot.StrokeColor.R = Utils.annotationOptions.selectedAnnotationColor.R;
    annot.StrokeColor.G = Utils.annotationOptions.selectedAnnotationColor.G;
    annot.StrokeColor.B = Utils.annotationOptions.selectedAnnotationColor.B;
    annot.StrokeColor.A = Utils.annotationOptions.selectedAnnotationColor.A;
    if (grow) {
      annot.X -= Utils.annotationOptions.selectedRectangeGrowthValue;
      annot.Y -= Utils.annotationOptions.selectedRectangeGrowthValue;
      annot.Width += 2 * Utils.annotationOptions.selectedRectangeGrowthValue;
      annot.Height += 2 * Utils.annotationOptions.selectedRectangeGrowthValue;
    }
  }

  public static styleHiddenRectangleAnnotation(annot: Core.Annotations.RectangleAnnotation): void {
    annot.StrokeThickness = Utils.annotationOptions.hiddenAnnotationBorderThickness;
    annot.StrokeColor.A = Utils.annotationOptions.hiddenAnnotationColor.A;
  }

  /* eslint-enable no-param-reassign*/

  public static getRepeatIcon(): HTMLImageElement {
    if (!Utils.repeatIcon) {
      Utils.repeatIcon = new Image();
      Utils.repeatIcon.src = `data:image/svg+xml;base64,${btoa(
        '<svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M14.0013 2H2.0013C1.33464 2 0.667969 2.66667 0.667969 3.33333V12.6667C0.667969 13.4 1.26797 14 2.0013 14H14.0013C14.668 14 15.3346 13.3333 15.3346 12.6667V3.33333C15.3346 2.66667 14.668 2 14.0013 2ZM14.0013 12.6133C13.988 12.6333 13.9613 12.6533 13.948 12.6667H2.0013V3.38667L2.05464 3.33333H13.9413C13.9613 3.34667 13.9813 3.37333 13.9946 3.38667V12.6133H14.0013ZM7.33464 10.34L5.66797 8.33333L3.33464 11.3333H12.668L9.66797 7.33333L7.33464 10.34Z" fill="white"/></svg>',
      )}`;
    }
    return Utils.repeatIcon;
  }
}

export enum AnnotationAction {
  ADD = 'add',
  MODIFY = 'modify',
  SELECTED = 'selected',
  DELETE = 'delete',
}
